// Boas-vindas do fundador e o link "Fale com o fundador", compartilhados pelo
// DashboardLayout (botão da topbar, menu do avatar e modal) e pelo
// FirstAccessView (mensagem dentro do cartão, antes das opções).

import { computed } from "vue";
import { useRoute } from "vue-router";
import { useUserStore } from "@/stores/useUserStore";
import { buildFounderWhatsAppUrl } from "@/utils/founderContact";
import { dismissFounderWelcome as dismissFounderWelcomeRequest } from "@/services/userService";

export function useFounderContact() {
  const route = useRoute();
  const userStore = useUserStore();

  // Montado na hora: a rota muda enquanto o layout continua montado.
  const founderWhatsAppUrl = computed(() =>
    buildFounderWhatsAppUrl({
      name: userStore.currentUser?.fullName || userStore.currentUser?.userName,
      email: userStore.currentUser?.email,
      screen: route.path,
    }),
  );

  const founderFirstName = computed(
    () => (userStore.currentUser?.fullName || "").trim().split(/\s+/)[0] || "",
  );

  // Só quando o backend diz explicitamente que ainda não foi vista. Usuário em
  // cache de antes do deploy vem sem o campo (undefined) e não deve vê-la.
  const founderWelcomePending = computed(
    () => userStore.currentUser?.founderWelcomeSeen === false,
  );

  // Esconde na hora e grava no backend; se a gravação falhar, a mensagem não
  // volta nesta sessão e reaparece no próximo login.
  async function dismissFounderWelcome() {
    if (userStore.currentUser) userStore.currentUser.founderWelcomeSeen = true;
    try {
      await dismissFounderWelcomeRequest();
    } catch (err) {
      console.error("[useFounderContact] Falha ao dispensar boas-vindas:", err);
    }
  }

  return {
    founderWhatsAppUrl,
    founderFirstName,
    founderWelcomePending,
    dismissFounderWelcome,
  };
}
